import CustomErrorComponent from 'src/components/custom-error/custom-error.component';
import PageHead from 'src/components/page-head/page-head.component';
import { getErrorPageHeader } from 'src/utils/pageheader';

export default function ErrorPage404() {
  return (
    <>
      <PageHead {...getErrorPageHeader()} />
      <CustomErrorComponent errorCode={404} errorMessage={null} />;
    </>
  );
}
